import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { sentinelModule } from "../modules/sentinelModule";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { validationsList_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { usageStats_template } from "../components/templates/usageStats_template";
import { vnApp_sentinelbi } from "../components/vnApp_sentinelbi";

declare var ko: any;
declare var page: any;

export class usageStats extends sentinelModule {

    protected XHRHdl: XMLHttpRequestHandler;
    protected usageStats_template: usageStats_template;

    protected getModuleName(){

        return "usageStats";
    }

    buildContent() : Array<Element>{

        const parentContent = super.buildContent();

        // create the usageStats list
        this.usageStats_template = new usageStats_template("usageStats", this.viewModel, this);
        this.template = this.usageStats_template;

        return [...parentContent, this.usageStats_template.build()];
    }

    fillPage() : void{

        this.getPermissions();
        this.getSearchPresetsListData();
    }

    protected getPermissions(){

        this.loadingIn(this.usageStats_template.builtTemplate);

        let accPermissions_url: string = '/api/settings/menuData';
        let accPermissions_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(accPermissions_url, accPermissions_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetPermissionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetPermissionsReturn(req, obj){

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                obj.loadingOut(obj.usageStats_template.builtTemplate);
                obj.usageStats_template.setSideMenuPermissionsData(responseParsed);
            })
        }
    }

    protected getListFormData(): void{

        this.loadingIn(this.usageStats_template.builtTemplate.querySelector("#dataStats-results"));

        let subViewModel = this.usageStats_template.getViewModelForRequest();

        let usrReq_url: string = '/api/settings/data_usage/references/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                    obj.updateFilters(responseParsed);
                    obj.updateViewModelFromPath();
                    obj.getListData();
            });

            obj.loadingOut(obj.usageStats_template.builtTemplate.querySelector("#dataStats-results"));
        }
    }

    protected updateFilters(responseParsed: any){

        this.usageStats_template.setBillingPeriodsFilter(responseParsed.billingPeriodIntervals);
    }

    public getListData(): void{

        this.loadingIn(this.usageStats_template.builtTemplate.querySelector("#dataStats-results"), true);

        let subViewModel = this.usageStats_template.getViewModelForRequest();
        let baseApiUrl = '/api/settings/data_usage/get';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getListData');
    }

    protected onDataRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.updateDailyUsageData(responseParsed.dataUsage);
                obj.udateUsageDataTotals(responseParsed.dateUsageTotals);
            });

            obj.loadingOut(obj.usageStats_template.builtTemplate.querySelector("#dataStats-results"), true);
        };
    }

    protected updateDailyUsageData(data){

        this.usageStats_template.updateDailyUsageData(data);
    }

    protected udateUsageDataTotals(data){

        this.usageStats_template.updateUsageDataTotals(data);
    }

    protected filterSingleGroupSelectorOnChange(){

        this.getListData();
    }
}



// WEBPACK FOOTER //
// ./js/modules/usageStats.ts